import script from "./AddIntentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddIntentModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddIntentModal.vue?vue&type=style&index=0&id=5548b33c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5548b33c"]])

export default __exports__